<template>
  <v-row justify="start">
    <v-dialog
      v-model="dialogSelectJourney"
      @click:outside="$emit('close')"
      scrollable
      max-width="500px"
    >
      <v-card class="rounded-max" color="#23003a">
        <v-toolbar dense flat color="#23003a">
          <p class="white--text text-center ma-0">Choose Your Next Journey</p>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <div v-if="list_journey">
              <v-row>
                <v-col
                  lg="4"
                  md="4"
                  cols="6"
                  v-for="journey in filteredList"
                  :key="journey.id"
                >
                  <router-link
                    class="decoration"
                    :to="`/journey/${journey.id}`"
                  >
                    <div class="d-flex align-center justify-center flex-column">
                      <div
                        class="rounded-img d-flex align-center justify-center"
                      >
                        <img :src="journey.path" class="img-journey" alt="" />
                      </div>
                      <p class="ma-0 white--text text-center">
                        {{ journey.misi }}
                      </p>
                    </div>
                  </router-link>
                </v-col>
              </v-row>
            </div>
            <div v-if="!list_journey">
              <h4 class="white--text">Sedang Memuat...</h4>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "selectJourney",

  props: ["dialogSelectJourney"],
  computed: {
    ...mapState({
      list_journey: (state) => state.list_journey,
    }),
  },
  data() {
    return {
      filteredList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let completed = JSON.parse(localStorage.getItem("completed"));
      this.$store.dispatch("listJourney").then((data) => {
        let act = data.data;
        act.forEach((el) => {
          console.log(el.misi.replace(/\s/g, "").toLowerCase(), el.misi);
        });
        if (completed) {
          this.filteredList = act.filter(
            ({ id: a }) => !completed.some(({ id: b }) => a === b)
          );
        } else {
          this.filteredList = act;
        }
      });
    },
  },
};
</script>
<style scoped>
.no_decoration {
  text-decoration: none;
}
.img-journey {
  height: 50px;
}
.rounded-img {
  height: 75px;
  width: 75px;
  background: white;
  border-radius: 50%;
}
.decoration {
  text-decoration: none;
}
</style>
